import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type ValidationTestDrawerContextType = {
  validationTestResultDetailContent: JSX.Element | undefined;
  setValidationTestResultDetailContent: Dispatch<
    SetStateAction<JSX.Element | undefined>
  >;
  validationTestResultOpen: boolean;
  setValidationTestResultOpen: Dispatch<SetStateAction<boolean>>;
};

const defaultValidationTestDrawerContext = null;

export const ValidationTestDrawerContext =
  createContext<ValidationTestDrawerContextType | null>(
    defaultValidationTestDrawerContext,
  );

export const useValidationTestDrawerContext = () => {
  const contextValue = useContext(ValidationTestDrawerContext);

  if (!contextValue) {
    throw new Error(
      'useValidationTestDrawerContext has to be used within <ValidationTestDrawerContextProvider>',
    );
  }

  return contextValue;
};

export const ValidationTestDrawerContextProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [
    validationTestResultDetailContent,
    setValidationTestResultDetailContent,
  ] = useState<JSX.Element | undefined>(undefined);

  const [validationTestResultOpen, setValidationTestResultOpen] =
    useState(false);

  return (
    <ValidationTestDrawerContext.Provider
      value={{
        validationTestResultDetailContent,
        setValidationTestResultDetailContent,
        validationTestResultOpen,
        setValidationTestResultOpen,
      }}
    >
      {children}
    </ValidationTestDrawerContext.Provider>
  );
};
